import React from 'react';
import { Typography } from '@material-ui/core';

import formatMoneyStrFriendly from '../../../libs/formatMoneyStrFriendly';
import formatHour from '../../../libs/formatHour';
export default function PhaseTotals({ totalPhaseHours, totalPhaseCost, totalPhasePrice }) {

    return (
        <div className="col s12 l8 m8 counting-phase">
            <div key="1">
                <span>Hours</span>
                <Typography variant="h4" component="h4" id="totalPhaseHours">
                    {formatHour({ number: totalPhaseHours })}
                </Typography>
            </div>
            <div key="2">
                <span>Cost</span>
                {formatMoneyStrFriendly({ number: totalPhaseCost, numberFormat: true, beFriendly: true, maximumFractionDigits: 0 })}
            </div>
            <div key="3">
                <span>Price</span>
                {formatMoneyStrFriendly({ number: totalPhasePrice, numberFormat: true, beFriendly: true, maximumFractionDigits: 0 })}
            </div>
        </div>
    )
}